import createVueComponent from '../createVueComponent';

const ChevronUp = createVueComponent('ChevronUpIcon', [
  ['path', { d: 'm18 15-6-6-6 6', key: '153udz' }],
]);

export default ChevronUp;
